module.exports = __webpack_public_path__ + "files/daf4710c9f421a5107f5d698849af9f7.svg";